import React from "react";
import { Button, Row, Col, Card, CardGroup } from "react-bootstrap";
import Image from "react-bootstrap/image";
import hero from "../images/hero.png";
import bulb from "../images/bulb.png";
import blocks from "../images/blocks.png";
import bolt from "../images/bolt.png";

export default function Home() {
  return (
    <div>
      <div
        style={{
          marginTop: "5%",
          marginBottom: "10%",
          marginLeft: "0px",
          marginRight: "0px",
        }}
      >
        {/* Hero */}{" "}
        <Row
          className="landing-row"
          style={{
            marginTop: "2%",
            paddingBottom: "4em",
            borderBottom: "2px solid black",
          }}
        >
          <Col md={6} sm={12} xs={12}>
            <div className="home-banner" style={{ padding: "4em" }}>
              <div className="home-banner-text-container">
                <div className="ellipse"></div>
                <div className="ellipse2"></div>
                <h1 className="h1-black">IGNITING THE ENERGY TRANSITION </h1>
                <div className="description">
                  <p style={{ marginTop: "5%" }}>
                    The AI assistant for renewable energy development.{" "}
                  </p>
                </div>
                {/* CTA */}
                <Button
                  className="btn-hover color-3"
                  style={{ borderRadius: "20px", margin: "0px" }}
                >
                  <a
                    href="https://forms.gle/JHb82K9MSJ3q8mJg7"
                    target="_blank"
                    style={{
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Join Waitlist
                  </a>
                </Button>
              </div>
            </div>
          </Col>
          <Col md={6} sm={12} xs={12}>
            <Image
              src={hero}
              style={{ width: "90%", alignContent: "center" }}
            />
          </Col>
        </Row>
        {/* Detail section */}
        {/* <Row
          className="landing-detail-section"
          style={{
            borderBottom: "1px solid black",
          }}
        >
          <h1
            className="h1-black"
            style={{ margin: "auto", marginTop: "5%", textAlign: "center" }}
          >
            GET FUNDED WITHOUT THE HASSLE
          </h1>
          <p style={{ textAlign: "center" }}>
            We help you find the right financing partner for your needs,
            location, and project type.
          </p>

          <CardGroup
            style={{
              marginTop: "5%",
              marginBottom: "5%",
              paddingLeft: "10%",
              paddingRight: "10%",
            }}
          >
            <Card className="value-prop">
              {" "}
              <Card.Body style={{ textAlign: "center" }}>
                <Card.Img variant="top" src={bolt} style={{ width: "20%" }} />
                <Card.Title>Submit an asset</Card.Title>
                <Card.Text>
                  A fast, simple and compliant experience for listing a project
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="value-prop">
              {" "}
              <Card.Body style={{ textAlign: "center" }}>
                <Card.Img variant="top" src={bulb} style={{ width: "20%" }} />
                <Card.Title>Get matched with high-quality investors</Card.Title>
                <Card.Text>
                  Immediately tap into a network of asset owners, banks and
                  financial institutions to find your ideal buyers.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card className="value-prop">
              {" "}
              <Card.Body style={{ textAlign: "center" }}>
                <Card.Img variant="top" src={blocks} style={{ width: "20%" }} />
                <Card.Title>Connect with vendors</Card.Title>
                <Card.Text>
                  While you're at it, suppliers, EPCs and subscription managers
                  who are ready to help you build.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
        </Row> */}
        {/* Join Waitlist */}
        <Row
          className="landing-row"
          style={{
            marginTop: "5%",
          }}
        >
          <Card
            className="card green"
            style={{
              borderRadius: "20px",
              margin: "auto",
              border: "0px",
              backgroundColor: "#F5F2EB",
              width: "70%",
              padding: "3em",
            }}
          >
            {" "}
            <Card.Body style={{ textAlign: "center" }}>
              <Card.Title style={{ color: "white" }}>
                <h1 style={{ fontFamily: "Montserrat" }}>COMING SOON</h1>
              </Card.Title>
              <Card.Text style={{ color: "white" }}>
                Contact us for a demo.
              </Card.Text>
              <br></br>
              <Button
                className="btn-hover color-3"
                style={{ borderRadius: "20px", margin: "auto" }}
              >
                <a
                  href="https://forms.gle/JHb82K9MSJ3q8mJg7"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "white",
                    textDecoration: "none",
                  }}
                >
                  Get In Touch
                </a>
              </Button>
            </Card.Body>
          </Card>
        </Row>
      </div>
    </div>
  );
}
